import { Component, Input, Output } from "rete";
import { DropdownControl, SwitchControl } from "../controls";
import Socket from "../sockets";
import Node from "./node-components/node";

export class SkimMatrixCalc extends Component {
  constructor(component) {
    super("SkimMatrix");
    this.data = {
      render: "vue",
      component: Node,
      props: { type: "calc", comp: component || null }
    };
    this.parentComp = component || null;
  }

  builder(node) {
    const calcInput = new Input("calculation-input", "", Socket["calc"]);
    const calcOutput = new Output("calculation-output", "", Socket["calc"]);
    const matrixOutput = new Output(
      "skim-output",
      "Матрица затрат",
      Socket["skim-matrix"]
    );

    if (node.data.switch === undefined) node.data.switch = true;

    return node
      .addInput(calcInput)
      .addControl(
        new SwitchControl(this.editor, "switch", "switcher", false, node)
      )
      .addControl(
        new DropdownControl(
          this.editor,
          "id",
          "skim",
          false,
          "Choose skimmatrix",
          this.parentComp
        )
      )
      .addOutput(calcOutput)
      .addOutput(matrixOutput);
  }

  worker(node, inputs, outputs) {
    outputs["skim-matrix-output"] = node.data.value;
  }
}
